export default {"src":"/_next/static/media/OrthodonticIssues.38a1aad2.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};